








































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';

import TitleBar from '@/components/Elements/TitleBar.vue'
import cloneDeep from 'lodash/cloneDeep';

import BatchesManagerForm from '@/modules/BatchesManager/BatchesManagerForm/BatchesManagerForm.vue'

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'filter', 'meta',

      'documents', 'lastMeta'
    ]),
  },
  components: {
    TitleBar
  }
})
export default class BatchesManager extends Vue {
  radioButton = 1;
  sortingPriority: any[] = [{"field": "name","order": "asc"}];

  get titleStack () {
    return [
      'Продукты', 'Сырье', 'Партии'
    ]
  }

  get queryParams() {
    return cloneDeep(this.$route.query);
  }

  get defaultSort() {
    return [this.$route.query.sortField || 'name', this.$route.query.sortDirection || 'asc']
  }

  get selectedView() {
    return this.$route.query.view || 'linked'
  }

  setFilter(filterName: string, filterValue: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        [filterName]: filterValue
      }
    })
  }
  // Backend sorting
  sortingPriorityRemoved(field: any) {
    this.sortingPriority = this.sortingPriority.filter(
      (priority) => priority.field !== field)
    this.onLoadData(this.sortingPriority)
  }

  onLoadData(sortingPriority: any) {
    this.$router.replace({
      query: {
        ...this.$route.query,
        sortFields: JSON.stringify(this.sortingPriority)
      }
    })
  }

  onSort(field: string, order: any, direction: string) {
    console.log('onSort', field, order, direction)
    const existingPriority = this.sortingPriority.filter(i => i.field === field)[0]
    if(existingPriority) {
      existingPriority.order = existingPriority.order === 'desc' ? 'asc' : 'desc'
    } else {
      // request sorted data from backend
      this.sortingPriority.push({field, order})
    }
    this.onLoadData(this.sortingPriority)
  }

  private delayFilter: any = null
  private delayFilterValue: any = null

  onSearch(filter: string, value: any) {
    if (!this.delayFilter) {
      setTimeout(() => {
        this.$router.replace({
      query: {
        ...this.$route.query, [this.delayFilter]: this.delayFilterValue
      }
    })
        this.delayFilter = null
      }, 3000)
    }
    this.delayFilter = filter
    this.delayFilterValue = value
  }

  onPageChange(page: string) {
    console.log('onPageChange', page)
    this.$router.replace({
      query: { ...this.$route.query, page }
    })
  }

  openDocument(row: any) {
    this.$buefy.modal.open({
      component: BatchesManagerForm,
      props: {
        isNew: !row || !row.id,
        documentPreview: row,
        initParams: {
          type: 'g'
        }
      },
      events: {
        'form-close': () => {
          this.handleParamsChange();
        },
      },
      hasModalCard: true,
      fullScreen: true,
      customClass: 'document-form short-form',
      parent: this
    })
    // this.$buefy.dialog.prompt({
    //   message: `Роль в смене`,
    //   inputAttrs: {
    //     placeholder: 'Наименование',
    //     value: row.name,
    //   },
    //   confirmText: 'Сохранить',
    //   cancelText: 'Отмена',
    //   trapFocus: true,
    //   onConfirm: (value: any) => {
    //     this.$store.dispatch(`${STORE_KEY}/saveTodoType`, {
    //       id: row.id,
    //       name: value
    //     })
    //     .then((result) => {
    //       this.$buefy.snackbar.open(`Запись успешно сохранена`);
    //       this.handleParamsChange();
    //     })
    //     .catch(() => {
    //       this.$buefy.snackbar.open({
    //         type: 'is-warning',
    //         message: `При сохранении возникли проблемы. Попробуйте позже.`
    //       })
    //     })
    //   }
    // })
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    this.handleParamsChange();
  }

  beforeDestroy() {
    this.$store.unregisterModule(STORE_KEY);
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query)
  }

}
